import Vue from "vue";
import Router from "vue-router";

import Dashboard from "../pages/Dashboard.vue";
import Projects from "../pages/Projects.vue";
import Employees from "../pages/Employees.vue";
import Timesheet from "../pages/Timesheet.vue";
import Expense from "../pages/Expense.vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Default",
      component: Dashboard
    },
    {
      path: "/dashboard",
      name: "Dashboard",
      component: Dashboard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/projects",
      name: "Projects",
      component: Projects,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/employees",
      name: "Employees",
      component: Employees,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/timesheet",
      name: "Timesheet",
      component: Timesheet,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/expense",
      name: "Expense",
      component: Expense,
      meta: {
        requiresAuth: true
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  let isLogin = false;
  if (localStorage.getItem("isAuthenticated") == "true") isLogin = true;
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  if (requiresAuth) {
    if (isLogin) next();
    else if (from.path && from.path == "/login") {
      next();
    } else {
      next("Login");
    }
  } else {
    next();
  }
});

export default router;
